import React from 'react';
import { useGalleryUI } from '../../../context/GalleryContext';
var galleryUiComponents = {
    videoPlayButton: React.lazy(function () { return import(/* webpackChunkName: "defaultPlayButton" */ './playButton'); }),
    rotateArrow: React.lazy(function () { return import(/* webpackChunkName: "defaultRotateArrow" */ './rotateArrow'); }),
};
export var GalleryUI = function (_a) {
    var type = _a.type, size = _a.size;
    var Component;
    var galleryUI = useGalleryUI();
    if (typeof (galleryUI === null || galleryUI === void 0 ? void 0 : galleryUI[type]) === 'function') {
        return galleryUI[type](size);
    }
    else if (galleryUiComponents[type]) {
        Component = galleryUiComponents[type];
    }
    else {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Suspense, { fallback: React.createElement(React.Fragment, null) },
        React.createElement(Component, { size: size })));
};
//# sourceMappingURL=GalleryUI.js.map